import { useStyles } from '../../../styles/NewOrUpdateForm.styles';
import { Grid, FormControl, MenuItem, Select, InputLabel, InputAdornment } from '@mui/material';
import RequireIcon from '@mui/icons-material/FiberManualRecord';

import type { FormComponentProps } from '@components/forms/types';

export type Option = { value: string | number; label: string; disabled?: boolean };

type FormSelectProps<State extends Record<string, any>> = FormComponentProps<State> & {
    label: string;
    options: Option[] | [];
    disable?: boolean;
    size?: number;
    stateKey: keyof State;
    required?: boolean;
    defaultFirst?: boolean;
};

export const FormSelect = <State extends Record<string, any>>({
    size,
    options,
    label,
    stateKey,
    disable,
    required,
    draft,
    defaultFirst = true,
}: FormSelectProps<State>) => {
    const classes = useStyles();
    const [state, dispatch] = draft;

    return (
        <Grid item md={size ?? 6} xs={12} sm={12} className={classes.textInputWrapper}>
            <FormControl fullWidth variant='outlined' className={classes.textInput}>
                <InputLabel id={`label-${label}`}>{label}</InputLabel>
                <Select
                    required={required}
                    onChange={(e) => {
                        dispatch((prev) => ({
                            ...prev,
                            [stateKey]: e.target.value,
                        }));
                    }}
                    value={state?.[stateKey] ?? (defaultFirst ? options[0].value : '')}
                    labelId={`label-${label}`}
                    displayEmpty
                    fullWidth
                    className={classes.textInput}
                    label={label}
                    disabled={disable}
                    error={required && !state?.[stateKey]}
                    startAdornment={
                        required ? (
                            <InputAdornment position='start'>
                                <RequireIcon fontSize='inherit' style={{ color: 'red' }} />
                            </InputAdornment>
                        ) : undefined
                    }>
                    {options.map(({ label, value, disabled }) => {
                        return (
                            <MenuItem key={`select-${label}`} value={value} disabled={disabled}>
                                {label}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Grid>
    );
};
